import { computed, ref } from 'vue';
import { defineStore } from 'pinia';

export const useViewportStore = defineStore(
  'viewport',
  () => {
    const width = ref<number>(window.innerWidth);
    const height = ref<number>(window.innerHeight);
    const isMobileSidebarOpen = ref<boolean>(false);

    // Example breakpoint; adjust as needed
    const isNarrow = computed<boolean>(() => width.value < 1200);
    const isMobile = computed<boolean>(() => width.value < 768);

    function setSize(newWidth: number, newHeight?: number) {
      width.value = newWidth;
      if (typeof newHeight === 'number') {
        height.value = newHeight;
      }
      // Close mobile sidebar when resizing to desktop
      if (!isMobile.value) {
        isMobileSidebarOpen.value = false;
      }
    }

    function toggleMobileSidebar() {
      isMobileSidebarOpen.value = !isMobileSidebarOpen.value;
    }

    function closeMobileSidebar() {
      isMobileSidebarOpen.value = false;
    }

    return {
      width,
      height,
      isNarrow,
      isMobile,
      isMobileSidebarOpen,
      setSize,
      toggleMobileSidebar,
      closeMobileSidebar,
    };
  },
  {
    persist: false, // viewport should not be persisted
  },
);
